module.exports = __webpack_public_path__ + "static/media/Backdrop-extreme.817a97c4.jpg";